<template>
    <v-container>
        <v-row no-gutters>
            <v-col cols="12">
                <back-button/>
            </v-col>
            <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
                <v-card color="transparent" flat v-if="paymentSet">
                    <v-card-title>{{ $t('payment.payment_method') }}</v-card-title>
                    <v-card-text>
                        <payment-card :owner-id="currentUser && currentUser.uid || null"
                                      :payment-method="account.stripeAccount.paymentMethod"/>
                    </v-card-text>
                </v-card>
                <div v-else class="white-card kimsa-elevation pa-0">
                    <card-creator @success="onCreateSuccess" @error="onCreateError"/>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3" class="pa-4">
                <subscription-status/>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import {mapState, mapMutations} from 'vuex'
import {db} from '@/utils/Firebase'
import CardCreator from "../../components/common/payment/CardCreator";
import PaymentCard from "../../components/common/payment/PaymentCard";
import SubscriptionStatus from "@/components/student/SubscriptionStatus";
import BackButton from "@/components/common/BackButton";

export default {
    name: "PaymentMethod",
    components: {BackButton, SubscriptionStatus, PaymentCard, CardCreator},
    props: {
        redirectToRoute: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            error: '',
            loading: false
        }
    },
    computed: {
        ...mapState(['account', 'currentUser']),
        paymentSet() {
            const vm = this
            return !!vm.account && !!vm.account.stripeAccount && !!vm.account.stripeAccount.paymentMethod
        }
    },
    methods: {
        async onCreateSuccess({paymentMethod}) {
            // console.log('paymentMethod', paymentMethod)
            const vm = this

            if (vm.account) {
                const {card, billing_details, id} = paymentMethod

                let paymentPayload = {
                    id: id,
                    billing_details: {name: billing_details.name},
                    card: {brand: card.brand, last4: card.last4}
                }

                const payload = {
                    'stripeAccount.paymentMethod': paymentPayload,
                    'stripeAccount.failedReason': '',
                    'stripeAccount.last4': null,
                }

                await db.collection('users').doc(vm.currentUser.uid).update(payload)
            }

            if (vm.redirectToRoute) await vm.$router.push(vm.redirectToRoute)
        },
        onCreateError(error) {
            const vm = this
            console.log('error', error)
        }
    },
}
</script>

<style scoped>

</style>